// extracted by css-extract-rspack-plugin
export default {"headerList":"DonationMatchRequestDetailsHeader_headerList__A50pO"};